<template>
    <div class="signup">
        <v-card color="transparent" dark width="500" class="mx-auto mt-5">
            <div class="text-center pt-4">
                <v-avatar :tile="true">
                    <img :src="require('@/assets/syn_logo.svg')" alt="logo">
                </v-avatar>
            </div>
            <v-card-title>
                <span class="px-3 synThickFont synLargeFont marginAlignCenter">Join SynthFeed</span>
            </v-card-title>

            <v-card-text >
                <v-form v-model="valid" dark ref="signupForm" v-on:submit.prevent="signup" class="px-3 black--text synThinFont">
                    <v-text-field 
                        label="Full Name or Artist Name" 
                        v-model="displayname"
                        :rules="displaynameRules"
                    ></v-text-field>
                    <v-text-field 
                        label="Username" 
                        v-model="username"
                        :rules="usernameRules"
                    ></v-text-field>
                    <v-text-field 
                        label="Email" 
                        v-model="email"
                        :rules="emailRules"
                    ></v-text-field>
                    <v-text-field 
                        label="Password" 
                        :type="'password'" 
                        v-model=password
                        :rules="passwordRules"
                    ></v-text-field>
                    <v-text-field 
                        label="Confirm Password" 
                        :type="'password'" 
                        v-model=confirmPassword
                        :rules="confirmPasswordRules"
                    ></v-text-field>
                    
                    <!-- :label="`Checkbox 1: ${checkbox.toString()}`" -->
                    
                        <v-row class="pl-2 d-none d-sm-flex ">
                            <v-checkbox
                            v-model="checkbox"  
                            ></v-checkbox> <span class="white--text mt-5">I agree to the <a class="rl-no-dec  syn_blue_button--text" target="_blank" href="/terms">Terms of Use</a> and <a class="rl-no-dec  syn_blue_button--text" target="_blank" href="/privacy">Privacy Policy</a></span>
                        </v-row>
                        
                        <v-row class="pl-2 d-flex d-sm-none " style="margin-top: -10px !important;">
                            <v-col cols="1">
                                <v-checkbox
                                class="text-center"
                                
                                v-model="checkbox"  
                                ></v-checkbox> 
                             </v-col>
                            <v-col class="pl-4 mt-5">
                                <span class="white--text" style="margin-top: -15px !important">I agree to the <a class="rl-no-dec  syn_blue_button--text" target="_blank" href="/terms">Terms of Use</a> and <a class="rl-no-dec  syn_blue_button--text" target="_blank" href="/privacy">Privacy Policy</a></span>
                            </v-col>
                        </v-row>
                        
                        <v-row class="pl-2 d-none d-sm-flex" style="margin-top: -15px !important">
                            
                            <v-checkbox
                            v-model="newsletterCheckbox"  
                            ></v-checkbox> 
                   
                            <span class="white--text mt-5">Yes, I would like to receive updates via the SynthFeed newsletter.</span>
                        </v-row>

                        <v-row class="pl-2 d-flex d-sm-none mb-2" style="margin-top:-30px !important">
                            <v-col cols="1">
                                <v-checkbox
                                v-model="newsletterCheckbox"  
                                ></v-checkbox> 
                            </v-col>
                            
                            <v-col class="pl-4 mt-5">
                                <span class="white--text ">Yes, I would like to receive updates via the SynthFeed newsletter.</span>
                            </v-col>
                        </v-row>
                    
                    
                    <div class='red--text '><span>{{feedback}}</span></div>                    
                    <div class="white--text mt-2">Already got an account? <a @click="signIn()">Sign In</a></div>
                    <div class="marginAlignCenter mt-7" >
                        <v-btn
                            color="syn_green"
                            depressed
                            class="mr-4 white--text synThickFont"
                            :loading="loading"
                            type="submit"
                        >
                            Sign Up
                        </v-btn>
                    </div>  
                </v-form>
            </v-card-text>

        </v-card>
        
    </div>
    
    
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import fb from '@/fb'
import slugify from 'slugify'

const db = fb.db
const functions = fb.functions

export default {
    name: 'Signup',
    data() {
        return {
            email: null,
            password: null,
            confirmPassword: null,
            username: null,
            displayname: null,
            valid:false,
            feedback: null,
            loading: false,
            slug: null,
            checkbox: false,
            newsletterCheckbox: true,
            emailRules: [
                v => !!v || 'Email is required',
            ],
            passwordRules: [
                v => !!v || 'Password is required',
            ],
            confirmPasswordRules: [
                v => (v === this.password) || 'Passwords must match'
            ],
            usernameRules: [
                v => !!v || 'Username is required',
                v => (v && v.length >= 3) || 'Username must be greater than 3 characters',
                v => (v && v.length <= 30) || 'Username must be less than 30 characters'
            ],
            displaynameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length >= 3) || 'Username must be greater than 3 characters',
                v => (v && v.length <= 30) || 'Username must be less than 30 characters'
            ]
        }
    },
    methods: {
        signup(){
            this.feedback= null
            this.loading = true
            
            // if (this.username && this.email && this.password) {
            if (this.valid && this.checkbox){
                this.slug = slugify(this.username, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower: true
                })
                // get reference to this slug's document in users collection
                
                let checkUsername = functions.httpsCallable('checkUsername')
                
                checkUsername({slug: this.slug}).then(result => {
                    if (!result.data.unique) {
                        this.feedback = 'This username already exists.'
                        this.loading = false
                    } else {
                        
                        firebase.auth().createUserWithEmailAndPassword(this.email,this.password)
                        .then(cred => {
                            db.collection('usernames').doc(this.slug).set({
                                username: this.username,
                                user_id: cred.user.uid,
                            }, { merge: true })
                            .catch(err => {
                                console.log(err);
                            })
                            return cred
                        }).then((cred)=>{
                            // console.log('working?');
                            db.collection('users').doc(cred.user.uid).set({
                                displayname: this.displayname,
                                username: this.username,
                                username_slug: this.slug,
                                user_id: cred.user.uid,
                                newsletter: this.newsletterCheckbox,
                                type: 'user'
                            })
                            .then(() => {
                                firebase.auth().currentUser.sendEmailVerification().then(function() {
                                    // Email sent.
                                    // console.log('email sent');
                                    window.fbq('track', 'CompleteSignUp');
                                }).catch(function(error) {
                                    // An error happened.
                                    console.log(error);
                                });
                            }).then(()=>{
                            
                                this.loading = false
                                
                                location.href = "/";
                            })
                            .catch(err => {
                                console.log(err);
                                this.feedback = err.message
                            })
                        })
                        .catch(err => {
                            console.log(err);
                            this.loading = false
                            this.feedback = err.message
                        })
                    }
                }).catch(err => {
                    console.log(err);
                    this.loading = false
                    this.feedback = 'Please try a different username, you might be using invalid characters.'
                })
            } else {
                this.loading = false
                this.feedback="You must enter all fields!"
            }
            
        },
        signIn(){
            this.$router.push({name:'Login'})
        }
    }
}
</script>

<style>
.signup{
      -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 1s; /* Firefox < 16 */
        -ms-animation: fadein 1s; /* Internet Explorer */
         -o-animation: fadein 1s; /* Opera < 12.1 */
            animation: fadein 1s;
} 
/* .signup .v-input .v-label{
    color:black !important;
} */
.signup .v-card{
    background-color: rgba(5,25,43,0.8) !important; 
    border: rgba(255,255,255,0.3) 1px solid !important;
}

</style>